<script>
  import ReportsService from "../../services/reports.service";
  import HrService from "../../services/hr.service";
  import { onMount } from "svelte";
  import Loader from '../../components/Loader.svelte';
  import { createEventDispatcher } from 'svelte';

  export let module, showGuide = false, guide_name = '', params;

  const dispatch = createEventDispatcher();

  let files = [], importing; 
  let message = {
      show: false,
      type: "",
      text: ""
  }

  let onImport = async function() {
    resetMessage();
    const urlDate = (module == 'staffing_budget')? '/date/' + params.year : '';
    const url = getOrg() + '/import/' + module + urlDate;
    const formData = new FormData();
    formData.append('file', files[0]);
    importing = true;
    try {
      const response = await HrService.import(formData, url);

      if (response && response.data.ok) {
          dispatch('imported', true);
      }else{
        message = {
          show: true,
          text: "Error: " + response.data.error,
          type: "danger"
        }
      }
    } catch (e) {
      message = {
        show: true,
        text: "Error: " + e.message,
        type: "danger"
      }
    } finally {
      importing = false;
    }
  }

  function getOrg() {
    return module === 'talent_tracking' ? '' : '/org/' + params.org; 
  }

  let resetMessage = function(){
      message = {
          show: false,
          text: "",
          type: ""
      }
  }
</script>

<div
  class="modal fade" id="importModal" tabindex="-1" role="dialog" aria-labelledby="importModal" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="importModalLabel">Import</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            {#if message.show}
              <div class="alert alert-{message.type} mt-3" id="message" role="alert">
                  {message.text}
                  <span class="float-right pointer" on:click={ resetMessage }>x</span>
              </div>
            {/if}   
          </div>
          {#if importing}
            <div class="col-md-12">
              <Loader></Loader>
            </div>
          {:else}
            <div class="col-md-12">
              <div class="form-group">
                <div class="form-control">
                  <input type="file" class="form-control-file" bind:files />
                </div>
              </div>
            </div>
            <div class="col-md-12 text-center">
              {#if showGuide}
                <a href="https://s3-us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/{guide_name}.pdf" target="_blank" class="btn btn-download mr-2">
                  <i class="fa fa-book mr-1"></i>
                  Import Guide
              </a>
              {/if}
              <a href="https://s3-us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/{module}.csv" download class="btn btn-download">
                  <i class="fa fa-file-excel-o mr-1"></i>
                  Download Template
              </a>
            </div>
          {/if}
        </div>
      </div>
      <div class="modal-footer text-right">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
        <button type="button" class="btn btn-success" disabled={files.length == 0} on:click={onImport}>
            Import
        </button>
      </div>
    </div>
  </div>
</div>
